export const SET_FEATURES = 'FETCH_FEATURES';